import { render, staticRenderFns } from "./PopupAutoRefund.vue?vue&type=template&id=a956ed48&scoped=true&"
import script from "./PopupAutoRefund.vue?vue&type=script&lang=js&"
export * from "./PopupAutoRefund.vue?vue&type=script&lang=js&"
import style0 from "./PopupAutoRefund.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PopupAutoRefund.vue?vue&type=style&index=1&id=a956ed48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a956ed48",
  null
  
)

export default component.exports